import { Box, Heading, Stack, Text } from '@chakra-ui/react';
import { Prose } from '@/components/ui/prose';

const Citation = () => {
  const currentYear = new Date().getFullYear();
  return (
    <Stack
      w='full'
      minHeight='content-height'
      overflow='auto'
      paddingTop={{ base: '4', md: '10' }}
      paddingBottom={{ base: '6', md: '16' }}
      paddingInline={{ base: 0, md: '8', lg: '12' }}
    >
      <Box>
        <Heading as='h1' size='2xl' mb='6'>
          Citation
        </Heading>

        <Heading as='h3' size='lg' mb='4'>
          Citing SKSIS:
        </Heading>
        <Stack gap='6'>
          <Box px='6' py='4' borderRadius='md' border='1px solid' borderColor='gray.200' bg='white'>
            <Prose maxWidth='full'>
              <Text as='blockquote' fontSize='sm' mb='6'>
                SKSIS Working Group {currentYear}. SKSIS: Saskatchewan Soil Information System. Available at:
                http://sksis.ca (access date).
              </Text>
            </Prose>
          </Box>
          <Box px='6' py='4' borderRadius='md' border='1px solid' borderColor='gray.200' bg='white'>
            <Heading as='h3' size='md' mb='2'>
              When citing soil survey information (Map Themes or Polygon/Component Information)
              viewed via SKSIS, please use the following citation:
            </Heading>
            <Prose maxWidth='full'>
              <Text as='blockquote' fontSize='sm' mb='6'>
                Saskatchewan Land Resource Unit 2009. SKSIDv4, Digital Soil Resource Information for
                Agricultural Saskatchewan, 1:100,000 scale. Agriculture and Agri-Food Canada,
                Saskatoon, SK. Accessed via SKSIS Working Group {currentYear}. SKSIS: Saskatchewan Soil
                Information System. Available at: http://sksis.ca (access date).
              </Text>
            </Prose>
          </Box>
        </Stack>
      </Box>
    </Stack>
  );
};

export default Citation;
